
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import LeadsList from "./LeadsList";
import LeadsHeader from "./LeadsHeader";
import { useLeads } from "./useLeads";
import LeadDetailModal from "./LeadDetailModal";
import { isBrowser } from "@/utils/runtime";

const LeadsModule: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const {
    leads,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
    filter,
    setFilter,
    refresh,
    fetchLastLead,
  } = useLeads();

  useEffect(() => {
    // Check if the modal should be opened with the latest lead
    const openParam = searchParams.get("open");
    if (openParam === "new") {
      // Fetch the most recent lead and open the modal
      fetchLastLead().then((lead) => {
        if (lead) {
          setSelectedLeadId(lead.id);
          setIsModalOpen(true);
        }
      });
      
      // Clear the URL parameter to prevent reopening on refresh
      setSearchParams({});
    }
  }, [searchParams]);

  const exportToExcel = () => {
    if (!isBrowser) return;
    // This function triggers the export in LeadsList
    const exportButton = globalThis.document.querySelector('[data-export-button]');
    if (exportButton) {
      (exportButton as HTMLButtonElement).click();
    }
  };

  const handleRowClick = (leadId: string) => {
    setSelectedLeadId(leadId);
    setIsModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLeadId(null);
  };

  return (
    <div className="space-y-6">
      <LeadsHeader 
        searchQuery={searchQuery} 
        setSearchQuery={setSearchQuery}
        filter={filter}
        setFilter={setFilter}
        refresh={refresh}
        exportToExcel={exportToExcel}
      />
      
      {error ? (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-md p-4">
          Erro ao carregar leads: {error}
        </div>
      ) : (
        <LeadsList 
          leads={leads} 
          isLoading={isLoading} 
          filter={filter}
          onRowClick={handleRowClick}
        />
      )}
      
      <LeadDetailModal
        leadId={selectedLeadId}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default LeadsModule;
